


































import { Component, Prop, Vue } from "vue-property-decorator";
import { getBaseFinishImage, getFinishImage } from "@/utility/helpers";
import {
  Finish,
  FinishDisplayName,
  FinishHandle
} from "@/models/products/finish";

@Component({
  directives: {
    "click-outside": {
      bind(el: any, binding: any) {
        el._clickOutside = (e: Event) => {
          if (!el.contains(e.target)) binding.value();
        };
        document.addEventListener("click", el._clickOutside);
      },
      unbind(el: any) {
        document.removeEventListener("click", el._clickOutside);
      }
    }
  }
})
export default class DropdownFinishes extends Vue {
  @Prop() finishes!: Finish[];
  @Prop() selected!: FinishHandle;
  /**
   * Draw from the base/cover swatch set instead of the frame finish one.
   *
   * Opt-in so the frame finish dropdown — every other caller — keeps the .png
   * images it has always shown. BugHerd #3 moved only the base and top cover
   * onto the older photography; without this the mobile dropdown would show a
   * different picture of the same finish than the desktop swatch beside it.
   */
  @Prop({ type: Boolean, default: false }) baseFinishes!: boolean;
  protected FinishDisplayName = FinishDisplayName;
  protected getFinishImage = getFinishImage;
  protected isOpen = false;

  protected swatchFor(handle: FinishHandle): string {
    try {
      return this.baseFinishes
        ? getBaseFinishImage(handle)
        : getFinishImage(handle);
    } catch (err) {
      // gbk has no asset in either set, and require() throws rather than
      // returning "". An empty swatch is what Shade Designer renders for it.
      return "";
    }
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  close() {
    this.isOpen = false;
  }

  public updateFinish(fieldValue: string) {
    this.$emit("updateItem", fieldValue);
    this.close();
  }

  get displayName(): string {
    if (this.selected) {
      const name = (this.selected as any).toUpperCase();
      return FinishDisplayName[name];
    } else {
      return "";
    }
  }
}
